module.exports = __webpack_public_path__ + "static/img/so4_2.3716b6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/so4_2.jpg
// module id = SPgP
// module chunks = 11